import { useAtom } from "jotai";
import { stornoDialogState } from "../store/StornoDialogStore";
import api from "../service/api";
import { useCallback } from "react";
import { toast } from "react-toastify"; // Assuming react-toastify is used for notifications
import { useTranslation } from "react-i18next";
import {
  offersPageRowsState,
  offersPageSkipState,
} from "../store/OffersPageStore";

export const useStornoDialog = () => {
  const [stornoDialog, setStornoDialog] = useAtom(stornoDialogState);
  const { t } = useTranslation();
  const [, setRows] = useAtom(offersPageRowsState);
  const [, setSkip] = useAtom(offersPageSkipState);

  const openStornoDialog = useCallback(
    (offerId: string) => {
      setStornoDialog({
        isOpen: true,
        offerId,
      });
    },
    [setStornoDialog]
  );

  const closeStornoDialog = useCallback(() => {
    setStornoDialog({
      isOpen: false,
      offerId: null,
    });
  }, [setStornoDialog]);

  const handleStornoOffer = useCallback(
    async ({
      offerId,
      stornoType,
    }: {
      offerId: string;
      stornoType: string;
    }) => {
      try {
        await api.invalidateOffer({ offerId, stornoType });
        toast.success(t("ila.storno.success"));
        // Refresh the list
        setRows([]);
        setSkip(0);
        return true;
      } catch (error) {
        console.error("Error cancelling offer:", error);
        toast.error(t("ila.storno.error"));
        throw error;
      }
    },
    [t, setRows, setSkip]
  );

  return {
    stornoDialog,
    openStornoDialog,
    closeStornoDialog,
    handleStornoOffer,
  };
};
